// @ts-nocheck -- staged migration: add explicit types before removing this directive.
// The 838 jinmeiyō ("name-use") kanji: characters additionally
// permitted for use in personal names by Japan's Ministry of Justice, on top
// of the jōyō kanji (see joyoKanji.js). kanjiapi.dev's jinmeiyō list has
// 863 entries in total; 0 of those are already covered as
// jōyō kanji and 25 are CJK compatibility-ideograph variants that render
// identically to a jōyō kanji and carry no separate meaning, so both groups
// are omitted here. Source: kanjiapi.dev (https://kanjiapi.dev).
export const jinmeiyoKanji = [
    "丑", "丞", "乃", "之", "乎", "乘", "也", "云", "亘", "亙", "些", "亞",
    "亥", "亦", "亨", "亮", "仔", "伊", "伍", "伶", "伽", "佃", "佑", "佛",
    "侃", "來", "侑", "俄", "俐", "俠", "俣", "俱", "倖", "倦", "倭", "偲",
    "傭", "傳", "僞", "價", "儉", "儲", "允", "兎", "兒", "兜", "其", "冨",
    "冴", "凉", "凌", "凛", "凜", "凧", "凪", "凰", "凱", "函", "剩", "劉",
    "劍", "劫", "勁", "勳", "勺", "勿", "匁", "匡", "卜", "卯", "卷", "卽",
    "卿", "厨", "厩", "叉", "叡", "叢", "只", "叶", "吞", "吻", "吾", "哉",
    "哨", "哩", "啄", "喋", "喧", "喬", "單", "喰", "嘉", "嘗", "嘩", "噂",
    "噌", "嚴", "圃", "圈", "國", "圓", "團", "圭", "坐", "坦", "埜", "埴",
    "堯", "堰", "堵", "堺", "塙", "增", "壕", "壘", "壞", "壬", "壯", "壽",
    "夷", "奄", "奎", "套", "奧", "奬", "姥", "姪", "娃", "娩", "嬉", "孃",
    "孜", "孟", "宋", "宏", "宕", "宥", "寅", "寓", "寢", "實", "寬", "寵",
    "將", "專", "尖", "尤", "尭", "屑", "峨", "峯", "峻", "峽", "崚", "嵩",
    "嵯", "嶋", "嶺", "巌", "巖", "巢", "巫", "已", "巳", "巴", "巷", "巽",
    "帖", "帶", "幌", "幡", "庄", "庇", "庚", "庵", "廟", "廣", "廳", "廻",
    "廿", "弘", "弛", "彈", "彌", "彗", "彦", "彪", "彬", "從", "徠", "徵",
    "德", "徽", "忽", "怜", "恆", "恕", "恢", "恰", "悉", "悌", "惇", "惚",
    "惟", "惠", "惡", "惣", "惹", "惺", "愼", "慧", "憐", "應", "懷", "戊",
    "或", "戟", "戰", "戲", "托", "拂", "拔", "拜", "按", "挺", "挽", "捧",
    "捲", "捷", "捺", "掠", "掬", "揃", "揭", "搖", "搜", "摑", "摺", "撒",
    "撞", "撫", "播", "撰", "擊", "擢", "攝", "收", "敍", "敦", "斐", "斡",
    "斧", "斯", "於", "旭", "昂", "昊", "昌", "昏", "昴", "晃", "晄", "晋",
    "晏", "晒", "晚", "晝", "晟", "晦", "晨", "智", "暉", "暢", "曆", "曉",
    "曙", "曝", "曳", "曾", "朋", "朔", "李", "杏", "杖", "杜", "杭", "杵",
    "杷", "枇", "柊", "柏", "柑", "柘", "柚", "柴", "柾", "栖", "栗", "栞",
    "桂", "桐", "桔", "桧", "桶", "梁", "梓", "梛", "條", "梢", "梧", "梯",
    "梶", "棲", "椀", "椋", "椛", "椰", "椿", "楊", "楓", "楕", "楚", "楠",
    "楢", "楯", "榊", "榎", "榛", "榮", "槇", "槌", "槍", "槙", "槻", "樂",
    "樋", "樟", "樣", "樫", "樺", "樽", "橘", "橙", "橫", "檀", "檎", "檜",
    "檢", "櫂", "櫓", "櫛", "櫻", "欣", "欽", "歎", "此", "步", "歷", "殆",
    "毅", "每", "毘", "毬", "氣", "汀", "汐", "汝", "汲", "沌", "沓", "沫",
    "洛", "洲", "洵", "洸", "浩", "浬", "涉", "淀", "淋", "淚", "淨", "淳",
    "淵", "渚", "渥", "渴", "渾", "湊", "湘", "湛", "溜", "溢", "溫", "滉",
    "滯", "漕", "漣", "漱", "澁", "澪", "濕", "濡", "瀕", "瀧", "瀨", "灘",
    "灸", "灼", "烏", "焚", "焰", "煉", "煌", "煤", "熙", "燈", "燎", "燒",
    "燕", "燦", "燭", "燿", "爭", "爲", "爾", "牒", "牟", "牡", "牽", "犀",
    "狀", "狹", "狼", "猪", "獅", "獸", "玖", "玲", "珀", "珂", "珈", "珊",
    "琉", "琢", "琥", "琳", "琵", "琶", "瑚", "瑛", "瑞", "瑳", "瑶", "瓜",
    "瓢", "甥", "甫", "畠", "畢", "疊", "疋", "疏", "瘦", "皐", "皓", "盃",
    "盜", "盡", "眞", "眸", "瞥", "矩", "砥", "砦", "砧", "硯", "碎", "碓",
    "碗", "碧", "碩", "磐", "磯", "祁", "祇", "祐", "祕", "祢", "祷", "祿",
    "禄", "禎", "禪", "禮", "禰", "禱", "禽", "禾", "秤", "秦", "稀", "稔",
    "稜", "稟", "稻", "穗", "穣", "穰", "穹", "穿", "窄", "窪", "窺", "竣",
    "竪", "竺", "竿", "笈", "笙", "笠", "笹", "筈", "筑", "箔", "箕", "篇",
    "篠", "簞", "簾", "籾", "粟", "粥", "粹", "糊", "紐", "紗", "紘", "紬",
    "絃", "絆", "絢", "綜", "綠", "綴", "綸", "綺", "綾", "緋", "緖", "緣",
    "縞", "縣", "縱", "繡", "繫", "纂", "纏", "纖", "羚", "翔", "翠", "耀",
    "而", "耶", "耽", "聡", "聽", "肇", "肋", "肴", "胡", "胤", "脩", "脹",
    "腔", "膏", "臟", "臥", "與", "舜", "舵", "芙", "芥", "芦", "芭", "芹",
    "苑", "苔", "苺", "茄", "茅", "茉", "茜", "茸", "荻", "莉", "莊", "莞",
    "莫", "菅", "菖", "菩", "菫", "菱", "萄", "萊", "萌", "萠", "萩", "萬",
    "萱", "葡", "董", "葦", "葵", "葺", "蒐", "蒔", "蒙", "蒲", "蒼", "蓉",
    "蓑", "蓬", "蓮", "蔓", "蔣", "蔦", "蔭", "蕃", "蕉", "蕎", "蕗", "蕨",
    "蕪", "蕾", "薗", "薙", "薩", "薰", "藁", "藏", "藝", "藥", "蘇", "蘭",
    "虛", "蝦", "蝶", "螺", "蟬", "蟹", "蠟", "衞", "衿", "袈", "袴", "裝",
    "裟", "裡", "裳", "襖", "覽", "訊", "訣", "註", "詢", "詫", "誼", "諄",
    "諏", "諒", "諺", "謂", "謠", "讃", "讓", "豹", "貰", "賑", "賣", "賴",
    "赳", "跨", "蹄", "蹟", "輔", "輯", "輿", "轉", "轟", "辰", "辻", "辿",
    "迂", "迄", "迦", "迪", "逗", "這", "逞", "逢", "遁", "遙", "遥", "遼",
    "邑", "郁", "郞", "鄭", "酉", "醇", "醉", "醍", "醐", "醬", "釀", "釉",
    "釘", "釧", "銑", "鋒", "鋸", "錄", "錆", "錐", "錘", "錫", "鍊", "鍬",
    "鎧", "鎭", "鑄", "閃", "閏", "閤", "阿", "陀", "陷", "隈", "險", "隼",
    "雀", "雁", "雛", "雜", "雫", "霞", "靖", "靜", "鞄", "鞍", "鞘", "鞠",
    "鞭", "頁", "頌", "頗", "顚", "顯", "颯", "飜", "饗", "馨", "馳", "馴",
    "駈", "駕", "駿", "騷", "驍", "驗", "髮", "魁", "魯", "鮎", "鯉", "鯛",
    "鰯", "鱒", "鱗", "鳩", "鳳", "鳶", "鴨", "鴻", "鵜", "鵬", "鷄", "鷗",
    "鷲", "鷹", "鷺", "麒", "麟", "麿", "黃", "黎", "黑", "默", "黛", "鼎",
    "齊", "龍", "欄", "廊", "朗", "虜", "類", "猪", "神", "祥", "福", "諸",
    "都", "侮", "勤", "卑", "墨", "層", "悔", "梅", "煮", "琢", "碑", "祐",
    "祖", "禍", "穀", "練", "署", "者", "臭", "賓", "贈", "響",
];
